import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import FoxTrader from "./../../../Images/foxtrader.png";
import "./FoxDownload.css";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState } from '../../features/User/UserSlice';


function FoxDownload() {
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const {  isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

          //  console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://www.foxtrader.in/registration/',
                '_blank' // <- This is what makes it open in a new window.
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
  return (
    <>
      <section className="fox-download">
        <Container>
          <Row>
            <Col md={5}>
              <div className="fox-download-img">
                <img className="img-fluid" src={FoxTrader} alt="FoxTrader" />
              </div>
            </Col>
            <Col md={7}>
              <div>
                <h3> FoxTrader</h3>
                <p>
                  As a promotional offer, you will receive a 7-day free trial of
                  FoxTrader. Download FoxTrader and install it. Follow the
                  simple installation instructions. Fill out the necessary
                  details and submit the registration form. FoxTrader is ready
                  to use after successful validation.
                </p>
                </div>
                <div>
                    <button type="button" onClick={() => clickToggleLoginPopup(true)} className="Login-Button-fox startnow_btn w-50 end-0">
                        Get Started
                    </button>
                </div>  
            </Col>
                  </Row>
                  <LoginPopup show={show} ref={childRef} />
        </Container>
      </section>
    </>
  );
}
export default FoxDownload;
